<template>
  <v-container>
    <div class="text-h4">
      Are you moving <b>tollfree</b> numbers from your previous provider?
    </div>
    <v-radio-group
      :value="getProductInfo().tf_numbers"
      @change="setPortingAnswer"
    >
      <v-radio label="Yes" value="y"></v-radio>
      <v-radio label="No" value="n"></v-radio>
    </v-radio-group>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'TollfreePorting',
  methods: {
    ...mapActions(['updateStoreFormData', 'updateNewNumbersField']),
    setPortingAnswer(newVal) {
      this.updateStoreFormData({
        data: newVal,
        main: this.getProductIdSelected,
        sub: 'tf_numbers',
      });
    },
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo']),
  },
};
</script>
